<!-- <template>
  <b-row>
    <b-col v-for="product in products" :key="product.category">
      <router-link v-tracker="'card:' + product.category" :to="{ name: product.route }">
        <b-card>
          <div class="text-center mb-2">
            <img
            class="px-25 mt-4 mb-2"
            style="width:8em"
            :src="product.image"
            :alt="product.category"
            />
            <h3 style="color:#024D67; font-weight:bold">{{product.category}}</h3>
          </div>
          <b-card-text style="height: 10rem;" class="text-center text-body c-text">
            {{ product.description }}
          </b-card-text>
        </b-card>
      </router-link>
    </b-col>
  </b-row>
</template>

<script>
import { BCol, BCard, BCardText, BRow } from 'bootstrap-vue'

export default {
  components: {
    BCol,
    BCard,
    BCardText,
    BRow,
  },

  data() {
    return {
      products: [
        {
          category: 'EBIS',
          description: "",
          image: require('@/assets/images/products/cfu/Icon - EBIS.png'),
          route: 'product-cfu-ebis',
        },
        {
          category: 'WINS',
          description: "",
          image: require('@/assets/images/products/cfu/Icon - WINS.png'),
          route: 'product-cfu-wibs',
        }
      ],
    }
  },
  mounted() {
    this.fetchProductSettings()
  },
  methods: {
    fetchProductSettings() {
      this.$http.get('/settings/product').then(({ data }) => {
        this.products[0].description = data.data.ebis
        this.products[1].description = data.data.wins
        this.products[2].description = data.data.cons
      })
    }
  }
}
</script> -->
<template>
  <b-row class="d-flex gap-3">
    <b-col cols="12" md="4" lg="6" class="d-flex flex-column" v-for="product in products" :key="product.category">
      <router-link class="d-flex flex-column flex-grow-1" style="margin-bottom: 2rem;" v-tracker="'card:' + product.category" :to="{ name: product.route }">
        <b-card class="py-2 d-flex flex-column flex-grow-1 mb-0">
          <b-card-body class="d-flex flex-column flex-grow-1">
            <div class="text-center mb-2">
              <img
                class="px-25 mb-2"
                style="width: 4em;"
                :src="product.image"
                :alt="product.category"
              />
              <h3 style="color:#024D67; font-size: 1rem; font-weight:bold">{{ product.category }}</h3>
            </div>
            <b-card-text class="text-center text-body c-text">
              {{ product.description }}
            </b-card-text>
          </b-card-body>
        </b-card>
      </router-link>
    </b-col>
  </b-row>
</template>

<script>
import { BCol, BCard, BCardText, BRow } from 'bootstrap-vue'

export default {
  components: {
    BCol,
    BCard,
    BCardText,
    BRow,
  },

  data() {
    return {
      products: [
        {
          category: 'EBIS',
          description: "",
          image: require('@/assets/images/products/cfu/Icon - EBIS.png'),
          route: 'product-cfu-ebis',
        },
        {
          category: 'WINS',
          description: "",
          image: require('@/assets/images/products/cfu/Icon - WINS.png'),
          route: 'product-cfu-wibs',
        }
      ],
    }
  },
  mounted() {
    this.fetchProductSettings()
  },
  methods: {
    fetchProductSettings() {
      this.$http.get('/settings/product').then(({ data }) => {
        this.products[0].description = data.data.ebis
        this.products[1].description = data.data.wins
        this.products[2].description = data.data.cons
      })
    }
  }
}
</script>
